export default "__VITE_ASSET__D7d9Y0$w__"